import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Component } from "react";
import locales from "../../../_constants/locales";
import "../styles/Item.css";
import ItemDetails from "./ItemDetails";

const getItemPicture = sku => {
    return `https://static.koboscm.com/images/RakutenKobo/devices/${sku}.png`;
};

class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isItemDetailsDialogOpen: false
        };
    }

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    handleReturnReasonChange(itemId, event, value) {
        let target = { ...event.target };
        target.name = "returnReason";
        target.value = value;
        event.target = target;
        this.handleChange(itemId, event);
    }

    handleChange(itemId, event) {
        this.props.handleChange(itemId, event);
    }

    getValue(fieldName) {
        if (this.props.item[fieldName]) {
            if (locales[this.props.language.code].ITEM.CONDITION.VALUE[this.props.item[fieldName]]) {
                return locales[this.props.language.code].ITEM.CONDITION.VALUE[this.props.item[fieldName]];
            }
        }

        return this.props.item[fieldName];
    }

    handleItemClick() {
        this.setState({
            isItemDetailsDialogOpen: true
        });
    }

    handleItemDetailClose() {
        this.setState({
            isItemDetailsDialogOpen: false
        });
    }

    render() {
        const quantityValue = Number(this.props.item.quantity);
        const shouldShowQuantityBadge = Number.isFinite(quantityValue) && quantityValue >= 2;

        return (
            <div className={`layout vertical item${this.props.clickable ? " clickable" : ""}`}>
                <div
                    className="layout horizontal center"
                    style={{ padding: "5px 0px", zIndex: this.props.clickable ? 10 : null }}
                    onClick={this.props.clickable ? this.handleItemClick.bind(this) : null}
                >
                    <div className="flex item-image-box relative">
                        <img className="item-image" src={getItemPicture(this.props.item.sku)} alt="" />
                        {shouldShowQuantityBadge && <p className={`item-quantity`}>{this.props.item.quantity}</p>}
                    </div>
                    <div className="custom-textfield-inactive">
                        <p className="custom-textfield-inactive-value">{this.props.item.title}</p>
                    </div>
                </div>
                {this.props.showDetails === true && this.props.type === "return" && (
                    <div className="flex layout vertical">
                        {this.props.disabled ? (
                            <div className="custom-textfield-inactive">
                                <p className="custom-textfield-inactive-label">{locales[this.props.language.code].ITEM.RETURN_REASON.LABEL}</p>
                                <p id="item-title" className="custom-textfield-inactive-value">
                                    {this.props.item.returnReason.label}
                                </p>
                            </div>
                        ) : (
                            <form
                                className="flex layout vertical"
                                autoComplete="off"
                                onSubmit={e => {
                                    e.preventDefault();
                                }}
                            >
                                <Autocomplete
                                    className="flex layout vertical custom-autocomplete"
                                    disabled={this.props.disabled}
                                    disableClearable
                                    value={this.props.item.returnReason}
                                    options={this.props.returnReasonList}
                                    getOptionLabel={option => option.label}
                                    renderInput={params => (
                                        <TextField
                                            autoComplete="off"
                                            className="custom-textfield select"
                                            {...params}
                                            label={locales[this.props.language.code].ITEM.RETURN_REASON.LABEL}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    )}
                                    onChange={this.handleReturnReasonChange.bind(this, this.props.item.id)}
                                />
                            </form>
                        )}
                        {this.props.item.returnReason && this.props.item.returnReason.label.toUpperCase() === "OTHER" && (
                            <div className="flex layout vertical">
                                {this.props.disabled ? (
                                    <div className="custom-textfield-inactive">
                                        <p className="custom-textfield-inactive-label">
                                            {locales[this.props.language.code].ITEM.RETURN_REASON_DESCRIPTION.LABEL}
                                        </p>

                                        <p id="item-return-reason-description" className="custom-textfield-inactive-value">
                                            {this.props.item.returnReasonDescription}
                                        </p>
                                    </div>
                                ) : (
                                    <form
                                        className="flex layout horizontal"
                                        autoComplete="off"
                                        onSubmit={e => {
                                            e.preventDefault();
                                        }}
                                    >
                                        <TextField
                                            autoComplete="off"
                                            error={
                                                this.props.item.validationErrors &&
                                                this.props.item.validationErrors.some(ve => ve.fieldName.toUpperCase() === "RETURNREASONDESCRIPTION")
                                            }
                                            helperText={
                                                this.props.item.validationErrors &&
                                                this.props.item.validationErrors.some(ve => ve.fieldName.toUpperCase() === "RETURNREASONDESCRIPTION")
                                                    ? this.props.item.validationErrors.filter(ve => ve.fieldName.toUpperCase() === "RETURNREASONDESCRIPTION")[0]
                                                          .errorMessage
                                                    : null
                                            }
                                            value={this.props.item.returnReasonDescription}
                                            disabled={this.props.disabled}
                                            className="flex custom-textfield"
                                            label={locales[this.props.language.code].ITEM.RETURN_REASON_DESCRIPTION.LABEL}
                                            variant="outlined"
                                            name="returnReasonDescription"
                                            onChange={this.handleChange.bind(this, this.props.item.id)}
                                            InputLabelProps={{
                                                shrink: true,
                                                htmlFor: "return_reason_description"
                                            }}
                                            inputProps={{ id: "return_reason_description", maxLength: 35 }}
                                        />
                                    </form>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {this.props.showDetails === true && this.props.type === "replacement" && (
                    <div className="flex layout vertical">
                        <div className="custom-textfield-inactive">
                            <p className="custom-textfield-inactive-label">{locales[this.props.language.code].ITEM.CONDITION.LABEL}</p>
                            <p className="custom-textfield-inactive-value">{this.getValue("condition")}</p>
                        </div>
                    </div>
                )}
                {this.props.clickable && (
                    <ItemDetails
                        open={this.state.isItemDetailsDialogOpen}
                        item={this.props.item}
                        handleClose={this.handleItemDetailClose.bind(this)}
                        language={this.props.language}
                        type={this.props.type}
                    />
                )}
            </div>
        );
    }
}

export default Item;
